"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Always import {h} from preact
var preact_1 = require("preact");
var BlogModule_1 = require("../components/BlogModule/BlogModule");
var targetNode = document.querySelector('.blog-module-section');
if (targetNode) {
    (0, preact_1.render)((0, preact_1.h)(BlogModule_1.default, null), targetNode);
}
